import { FC, PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';

import { messages } from './LocaleProvider.constants';
import { useTypedSelector } from '../../hooks/useTypedSelector';

const LocaleProvider: FC<PropsWithChildren> = ({ children }) => {
  const userLang = useTypedSelector(state => state.common.lang)

  return (
    <IntlProvider messages={messages[userLang]} locale={userLang}>
      {children}
    </IntlProvider>
  );
};

export default LocaleProvider;
